import { render, staticRenderFns } from "./index.vue?vue&type=template&id=027a268a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=027a268a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\taiqiu\\back-end\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('027a268a')) {
      api.createRecord('027a268a', component.options)
    } else {
      api.reload('027a268a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=027a268a&", function () {
      api.rerender('027a268a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TxMap/index.vue"
export default component.exports